
import {ref, reactive} from "vue";

export default function () {
    const defaultWidth = ref(480)
    const defaultHeight = ref(480)
    const tlSensorDefaultWidth = ref(400)
    const tlSensorDefaultHeight = ref(400)
    const modeVertical = reactive([
        { value: 'static', label: 'static' },
        { value: 'dynamic', label: 'dynamic' },
    ])
    const SensorVertical = reactive([
        { value: 'CPUTemperature', label: 'CPUTemp' },
        { value: 'CPULoad', label: 'CPULoad' },
        { value: 'GPUTemperature', label: 'GPUTemp' },
        { value: 'GPULoad', label: 'GPULoad' },
        { value: 'PumpRPM', label: 'PumpRPM' },
        { value: 'CoolantTemp', label: 'CoolantTemp' },
    ])
    const showTextsList = reactive([
        "CPULoad",
        "CPUTemperature",
        "GPULoad",
        "GPUTemperature",
        "PumpRPM",
        "CoolantTemp"
    ])

    const showTextsListOptions = reactive([
        { label: 'CPULoad', value: 'CPULoad' },
        { label: 'CPUTemperature', value: 'CPUTemperature' },
        { label: 'GPULoad', value: 'GPULoad' },
        { label: 'GPUTemperature', value: 'GPUTemperature' },
        { label: 'PumpRPM', value: 'PumpRPM' },
        { label: 'CoolantTemp', value: 'CoolantTemp' },
    ])

    const showTextsListOptionsWithThreeSensor = reactive([
        { label: 'CPULoad', value: 'CPULoad' },
        { label: 'CPUTemperature', value: 'CPUTemperature' },
        { label: 'GPULoad', value: 'GPULoad' },
        { label: 'GPUTemperature', value: 'GPUTemperature' },
        { label: 'CoolantTemp', value: 'CoolantTemp' },
    ])

    const textMode = reactive([
        { label: 'None', value: 'None' },
        { label: 'SliderSensor', value: 'SliderSensor' },
        { label: 'Time', value: 'Time' },
        { label: 'Custom', value: 'Custom' }
    ])

    const textModeIncludeDuo = reactive([
        { label: 'None', value: 'None' },
        { label: 'SliderSensor', value: 'SliderSensor' },
        { label: 'DuoSensor', value: 'DuoSensor' },
        { label: 'ThreeSensor', value: 'ThreeSensor' },
        { label: 'FourSensor', value: 'FourSensor' },
        { label: 'Time', value: 'Time' },
        { label: 'Custom', value: 'Custom' }
    ])


    const textBoxPositionVertical = reactive([
        { value: 'Top', label: 'vertical-top' },
        { value: 'Center', label: 'vertical-center' },
        { value: 'Bottom', label: 'vertical-bottom' },
    ])

    const textBoxPositionHorizontal = reactive([
        { value: 'Left', label: 'horizontal-left' },
        { value: 'Center', label: 'horizontal-center' },
        { value: 'Right', label: 'horizontal-right' }
    ])


    const leftTextBoxPositionHorizontal = reactive([
        { value: 'Left', label: 'horizontal-left' },
    ])

    const rightTextBoxPositionHorizontal = reactive([
        { value: 'Right', label: 'horizontal-right' }
    ])


    const textAlignments = reactive([
        { value: 'Left', label: 'left' },
        { value: 'Center', label: 'center' },
        { value: 'Right', label: 'right' }
    ])

    const SpeedVertical = reactive([
            { value: 10, label: '1' },
            { value: 20, label: '2' },
            { value: 30, label: '3' },
            { value: 40, label: '4' },
            { value: 50, label: '5' }
        ])

    const fontSizeVertical = reactive([
        { value: 65, label: '大' },
        { value: 43, label: '中' },
        { value: 25, label: '小' },
    ])

    const fontSizeCenterVertical254275 = reactive([
        { value: 75, label: '大' },
        { value: 42, label: '中' },
        { value: 25, label: '小' },
    ])

    const fontSizeCenterVertical284275 = reactive([
        { value: 75, label: '大' },
        { value: 42, label: '中' },
        { value: 28, label: '小' },
    ])

    const fontSizeCenterVertical284875 = reactive([
        { value: 75, label: '大' },
        { value: 48, label: '中' },
        { value: 28, label: '小' },
    ])

    const fontSizeCenterVertical253575 = reactive([
        { value: 75, label: '大' },
        { value: 35, label: '中' },
        { value: 25, label: '小' },
    ])

    const fontFamilyVertical = reactive([
        { value: '', label: 'default' },
        { value: 'AbrilFatface', label: 'AbrilFatface' },
        { value: 'AgencyGothicCT_Bold', label: 'AgencyGothicCT_Bold' },
        { value: 'Caprasimo_Regular', label: 'Caprasimo_Regular' },
        { value: 'GoodTimesRg_Italic', label: 'GoodTimesRg_Italic' },
        { value: 'HyperspaceRace_BoldItalic', label: 'HyperspaceRace_BoldItalic' },
        { value: 'LTCFournierLeJeune_Regular', label: 'LTCFournierLeJeune_Regular' },
        { value: 'ManoloMono_Regular', label: 'ManoloMono_Regular' },
        { value: 'NotoSansTC_Regular', label: 'NotoSansTC_Regular' },
        { value: 'NotoSansTC_Bold', label: 'NotoSansTC_Bold' },
        { value: 'Cubic11', label: 'Cubic11' },
        { value: 'BakerieSmooth_WideMediumRegular', label: 'BakerieSmooth_WideMediumRegular' },
    ])

    const fontFamilyVerticalWithSensor = reactive([
        { value: '', label: 'default' },
        { value: 'LTCFournierLeJeune_Regular', label: 'LTCFournierLeJeune_Regular' },
        { value: 'Caprasimo_Regular', label: 'Caprasimo_Regular' },
        { value: 'NotoSansTC_Bold', label: 'NotoSansTC_Bold' },
        { value: 'ManoloMono_Regular', label: 'ManoloMono_Regular' },
        { value: 'HyperspaceRace_BoldItalic', label: 'HyperspaceRace_BoldItalic' },
        { value: 'GoodTimesRg_Italic', label: 'GoodTimesRg_Italic' },
    ])



    return {
        defaultWidth,
        defaultHeight,
        tlSensorDefaultWidth,
        tlSensorDefaultHeight,
        modeVertical,
        SensorVertical,
        showTextsList,
        showTextsListOptions,
        showTextsListOptionsWithThreeSensor,
        textMode,
        textModeIncludeDuo,
        textBoxPositionVertical,
        leftTextBoxPositionHorizontal,
        rightTextBoxPositionHorizontal,
        textBoxPositionHorizontal,
        textAlignments,
        SpeedVertical,
        fontFamilyVertical,
        fontFamilyVerticalWithSensor,
        fontSizeVertical,
        fontSizeCenterVertical254275,
        fontSizeCenterVertical284275,
        fontSizeCenterVertical284875,
        fontSizeCenterVertical253575
    }
}
